import Vue from "vue";
import VueRouter from "vue-router";

import AccountView from "./components/AccountView";
import UsersView from "./components/UsersView";
import SubmissionsView from "./components/SubmissionsView";
import DocumentsView from "./components/DocumentsView";
import SurveyView from "./components/SurveyView";
import MemberView from "./components/MemberView";
import PaymentView from "./components/PaymentView";
import Success from "./components/Success";
import BoothInformation from "./components/BoothInformation";
import BoothOverview from "./components/BoothOverview";
import AdditionalBookings from "./components/AdditionalBookings";
import VirtualExhibition from "./components/VirtualExhibition";

Vue.use(VueRouter);

const routes = [
  // { path: "/", redirect: { name: "account-page" } },
  { path: "/account", name: "account-page", component: AccountView },
  { path: "/users", name: "users-page", component: UsersView },
  { path: "/membership", name: "member-page", component: MemberView },
  { path: "/membership/payment", name: "payment-page", component: PaymentView },

  { path: "/payment-success", name: "success-page", component: Success },
  {
    path: "/submissions",
    name: "submissions-page",
    component: SubmissionsView,
  },
  {
    path: "/documents/:type",
    name: "documents-page",
    component: DocumentsView,
  },
  { path: "/surveys", name: "survey-page", component: SurveyView },
  {
    path: "/booth-information",
    name: "booth-information-page",
    component: BoothInformation,
  },
  {
    path: "/booth-overview",
    name: "booth-overview",
    component: BoothOverview,
  },
  {
    path: "/booth-information/payment",
    name: "booth-payment-page",
    component: PaymentView,
    props: true,
  },
  {
    path: "/additional-bookings",
    name: "additional-bookings-page",
    component: AdditionalBookings,
  },
  {
    path: "/virtual-exhibition",
    name: "virtual-exhibition-page",
    component: VirtualExhibition,
  },
];

export const router = new VueRouter({ routes });
